import { setFoulsOnPeriod } from 'modules/stream/store/game-info/game-info';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import { DivProps } from '../../../../../typings';
import { selectPopup } from '../../../store/overlay/selectors';
import useGameInfo from '../../hooks/use-game-info';
import Counter from './counter';

interface IProps extends DivProps {
  teamIndex: number;
  period: number;
}

function Fouls(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { teamIndex, period, ...rest } = props;

  const { fouls } = useGameInfo();
  const popup = useSelector(selectPopup);
  const prefix = teamIndex === 0 ? 'first' : 'second';

  const teamScore = useMemo(() => {
    return fouls?.[prefix] ?? 0;
  }, [fouls, prefix]);

  const handleChangeFouls = useCallback(
    (newValue: number) => {
      dispatch(setFoulsOnPeriod({ [prefix]: newValue, period }));
      popup?.postMessage(JSON.stringify({ type: 'setFouls', [prefix]: newValue, period }));
    },
    [dispatch, popup, prefix],
  );

  return <Counter setValue={handleChangeFouls} value={teamScore} title={'Фолы'} titleWidth={40} {...rest} />;
}

export default Fouls;
